import { array, object } from "yup";

import Validations from "@src/utility/helpers/validations";
import size from "lodash/size";
import useAxios from "@src/utility/hooks/use-axios";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const defaultValues = {
    _id     : "",
    name    : "",
    email   : "",
    phone   : "",
    skype_id: "",
    role    : "admin",
    tags    : []
};

const useUpsert = (props) => {
    const { axiosInstance, loading } = useAxios({ base: "panel" });
    const { clientId, platformId } = useParams();
    const { handleModal, modalConfig:{ row }, getPeoples, isEdit } = props;
    const { emailRequiredValidation, validateIfPresent, regexValidation, requiredValidation } = Validations();

    const SKYPE_REGEX = {
        pattern: /^[a-zA-Z][a-zA-Z0-9,._-]*$/,
        msg    : "Must start with a letter and contain only letters, numbers, hyphens (-), periods (.), or underscores (_). No spaces or special characters allowed."
    };
    const methods = useForm({
        defaultValues,
        resolver: yupResolver(
            object({
                name : requiredValidation({ name: "Name" }),
                email: emailRequiredValidation({ name: "Email" }),
                phone: regexValidation({ regex: {
                    pattern: /^$|^\+\d{10,15}$/,
                    msg    : "Please enter a valid phone number in the format +1234567890."
                } }),
                skype_id: validateIfPresent({ name: "Skype Id", min: 6, regex: SKYPE_REGEX }),
                role    : requiredValidation({ name: "Role" }),
                tags    : array()
            })
        )
    });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        if (size(row)) {
            reset({
                ...row,
                tags: row.tags?.filter(item => item.name).map((item) => ({ value: item._id, label: item.name }))
            });
        } else {
            reset(defaultValues);
        }
    }, [row]);

    const onSubmit = async () => {
        handleSubmit(async (formData) => {            
            const payload = {
                name    : formData.name,
                email   : formData.email,
                phone   : formData.phone,
                skype_id: formData.skype_id,
                role    : formData.role,
                org_id  : clientId,
                tags    : formData.tags?.map((item) => item.value)
            };            
            if (isEdit) {
                await axiosInstance.put(`/people/${platformId}/${row._id}`, payload);
            } else {
                await axiosInstance.post(`/people/${platformId}`, payload);
            }
            getPeoples();
            handleModal();
        })();
    };
    
    return {
        methods,
        onSubmit,
        loading
    };
};
export default useUpsert;